module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', [_c('header', {
    staticClass: "view__header"
  }, [_c('h2', {
    staticClass: "view__title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('list', {
    staticClass: "view__content",
    attrs: {
      "data": _vm.entries(),
      "fields": _vm.headers(),
      "pagination": _vm.pagination,
      "progress-value": _vm.progressValue,
      "hideCreate": false,
      "hideSearch": false,
      "hideExport": false,
      "isLoading": _vm.isLoading
    },
    on: {
      "action": _vm.action,
      "paginate": _vm.paginate,
      "search": _vm.search
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-15191c90!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/members/Members.vue
// module id = 710
// module chunks = 1